import { render, staticRenderFns } from "./ReviewDashboardLanding.vue?vue&type=template&id=1b69cc02&scoped=true&"
import script from "./ReviewDashboardLanding.vue?vue&type=script&lang=js&"
export * from "./ReviewDashboardLanding.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDashboardLanding.vue?vue&type=style&index=0&id=1b69cc02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b69cc02",
  null
  
)

export default component.exports